import { logError } from "@/shared/logging/errors";
import { DomUtil } from "@/shared/ui/Helper";

export class PullToRefresh {
    private $element;
    private $ptr: JQuery;

    private readyDistance = 60;
    private maxDistance = 400;
    private pStart = 0;
    private isReady = false;

    private handler: { (): Promise<void> };

    constructor($element: JQuery, handler: { (): Promise<void> }) {
        this.$element = $element;
        this.$element.parent().addClass("ptr");

        this.$ptr = $('<div class="ptrcont"><i class="fal fa-arrow-down"></i></div>').insertBefore(this.$element);

        this.handler = handler;

        $element[0].addEventListener(
            "touchstart",
            (e) => {
                this.swipeStart(e);
            },
            false
        );
        $element[0].addEventListener(
            "touchmove",
            (e) => {
                this.move(e);
            },
            false
        );
        $element[0].addEventListener(
            "touchend",
            () => {
                this.swipeEnd();
            },
            false
        );
    }

    private move(e) {
        let pCurrent = 0;
        if (typeof e["targetTouches"] !== "undefined") {
            const touch = e.targetTouches[0];
            pCurrent = touch.screenY;
        } else pCurrent = e.screenY;

        let deltaY = pCurrent - this.pStart;
        if (deltaY < 0) deltaY = 0;
        else if (deltaY > this.maxDistance) deltaY = this.maxDistance;

        const distance = deltaY + DomUtil.momentumResistance(deltaY, 150);
        this.isReady = distance > this.readyDistance;
        if (deltaY !== 0 && e.cancelable) e.preventDefault();

        this.$ptr.css("min-height", distance);
        this.$element.css({ "margin-top": distance, "margin-bottom": distance * -1 });

        const hascl = this.$ptr.hasClass("readytoflick");
        if (this.isReady && !hascl) this.$ptr.addClass("readytoflick");
        else if (!this.isReady && hascl) this.$ptr.removeClass("readytoflick");
    }

    private swipeStart(e) {
        this.$ptr.removeClass("successful").find("> .fal").show();
        this.maxDistance = this.$element.height();
        const scrollOffset = this.$element.scrollTop();
        if (typeof e["targetTouches"] !== "undefined") {
            const touch = e.targetTouches[0];
            this.pStart = touch.screenY;
        } else this.pStart = e.screenY;

        this.pStart += scrollOffset;

        this.$ptr.removeClass("successful").stop(true, false);
        this.$element.stop(true, false);
    }

    private async swipeEnd() {
        if (this.isReady) {
            this.$ptr.find("> .fal").hide();
            const loader = $('<div class="loader" />').appendTo(this.$ptr);
            try {
                await this.handler();
            } catch (ex) {
                logError(ex);
            } finally {
                loader.remove();
                this.$ptr.addClass("successful");
                this.reset();
            }
        } else {
            this.reset();
        }
    }

    private reset() {
        this.$ptr.stop(true, false).animate({ "min-height": 0 }, 500, "easeOutExpo");
        this.$element.stop(true, false).animate({ marginTop: 0 }, 500, "easeOutExpo", () => {
            this.$ptr.removeClass("successful").find("> .fal").show();
        });

        this.isReady = false;
    }

    public destroy() {
        //remove event listeners
    }
}
